<template>
  <el-row>
    <el-col :span="10" :offset="7">
      <div>
        <el-form status-icon label-width="120px" class="demo-ruleForm">
          <el-form-item label="Username" prop="pass">
            <el-input v-model="user.username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="pass">
            <el-input v-model="user.password" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="OTP (if enabled)" prop="pass">
            <el-input v-model="user.otp" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleLogin()">Login</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<style>
</style>

<script>
import { Authenticate } from "../api.js";

export default {
  name: "Login",
  props: ["login"],
  data: function() {
    return {
      user: {}
    };
  },
  methods: {
    async handleLogin() {
      const data = await Authenticate(this.user.username, this.user.password, this.user.otp);
      if (data.token) {
        this.$emit("login", data);
      }
    }
  }
};
</script>